import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import { Tooltip } from "../Tooltip";
import styles from "./activationHistory.module.css";
import InforIcon from "../../assets/InfoCircleIcon";
import SimpleBackIcon from "../../assets/simpleBackIcon.svg";
import DatePickerModal from "../DatePicker";
import DownIcon from "../../assets/DownIcon";
import FilterIcon from "../../assets/FilterIcon";
import RunningIcon from "../../assets/running.gif";
import SearchModal from "../SearchModal";
import { AuthContext } from "../../contexts/auth-context";
import { useAsyncFn } from "../../hooks/use-async-fn";
import { useParams } from "react-router-dom";
import Dropdown from "../DropdownModal";
import {
  formatAdserverType,
  getCSSVariable,
  formatDateTime,
  formatDateTimeParts,
} from "../../utils";
import { useLocation } from "react-router-dom";
import { useBreadcrumb } from "../Breadcrumb/BreadcrumbContext";
import { useToast } from "../../contexts/toast-context";
import { useHistory } from "react-router-dom";
import { useSidebar } from "../NewSideBar/SidebarContext";
import NoData from "../NoData";
import DoneIcon from "../../assets/done.svg";
import CopyIcon from "../../assets/CopyIcon";
import TrailIcon from "../../assets/TrailIcon";
import DeletedIcon from "../../assets/verifyFailed.svg";
import IncompleteIcon from "../../assets/incomplete.svg";
import DiffIcon from "../../assets/diffIcon.svg";
import StaleIcon from "../../assets/staleIcon.svg";
import RedInfo from "../../assets/redinfo.svg";
import PageNotFound from "../PageNotFound";
import { PlayIcon } from "../../assets/PlayIcon";
import { PauseIcon } from "../../assets/PauseIcon";
import DownloadButton from "../DownloadButton";
import InfoIcon from "../../assets/InfoIcon";
import InfoPopup from "../InfoPopup";
import LayoutContainer from "../LayoutContainer";
import TableShimmer from "../../components/TableShimmer";
import ColHeader from "../ColHeader";
import {
  MdDescription,
  MdFingerprint,
  MdSync,
  MdCheckCircle,
  MdCalendarToday,
  MdCode,
  MdGroups,
} from "react-icons/md";

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000;

type ErrorPart = {
  label: string | null;
  value: string;
  variant?: "badge" | "code" | "json" | "text";
};

/**
 * Generic transfer-error parser.
 * Extracts whatever structure is present — HTTP status code, URL, HTML body,
 * JSON body — and falls back to a plain-text block when nothing matches.
 */
function parseTransferError(raw: string): ErrorPart[] {
  if (!raw?.trim()) return [{ label: null, value: raw, variant: "text" }];

  const parts: ErrorPart[] = [];
  let rest = raw.trim();

  // 1. HTTP status code: [NNN]
  const codeMatch = rest.match(/\[(\d{3})\]/);
  if (codeMatch) {
    const codeStart = rest.indexOf(codeMatch[0]);
    const before = rest.slice(0, codeStart).trim();
    if (before) parts.push({ label: "Error", value: before, variant: "text" });
    parts.push({ label: "Status", value: codeMatch[1], variant: "badge" });
    rest = rest.slice(codeStart + codeMatch[0].length).trim();
  }

  // 2. URL followed by ": <body>"
  const urlMatch = rest.match(/^(https?:\/\/[^\s]+?):\s+([\s\S]*)$/);
  if (urlMatch) {
    parts.push({ label: "Endpoint", value: urlMatch[1], variant: "code" });
    rest = urlMatch[2].trim();
  }

  // 3. Classify remaining body
  if (rest) {
    const hasHtml = /<\w/.test(rest);
    const hasJson = /^\s*[{[]/.test(rest);
    const responseLabel = parts.length ? "Response" : null;

    if (hasHtml) {
      const stripped = rest
        .replace(/<[^>]+>/g, "")
        .replace(/[\r\n]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      if (stripped) parts.push({ label: responseLabel, value: stripped, variant: "text" });
    } else if (hasJson) {
      try {
        const pretty = JSON.stringify(JSON.parse(rest), null, 2);
        parts.push({ label: responseLabel, value: pretty, variant: "json" });
      } catch {
        parts.push({ label: responseLabel, value: rest, variant: "text" });
      }
    } else {
      parts.push({ label: responseLabel, value: rest, variant: "text" });
    }
  }

  return parts.length ? parts : [{ label: null, value: raw, variant: "text" }];
}

const ActivationHistory = () => {
  const {
    getOrgByFederationID,
    getmatchratequery,
    getConfig,
    getActivationHistoryExport,
  } = useContext(AuthContext);
  const { setBreadcrumbItems } = useBreadcrumb();
  const { showToast } = useToast();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [visiblePages, setVisiblePages] = useState([1, 2, 3]);
  const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [openSearchMetadataModal, setOpenMetadataModal] = useState(false);
  const [filter_query] = useState<any>(undefined);
  const [filterEventName] = useState<any>(undefined);
  const [filterOrgName] = useState<any>(undefined);
  const [openParticipantsDropdown] =
    useState(false);
  const [openEventTypeDropdown] = useState(false);
  const [filterValue, setFilterValue] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const currentPageRef = useRef<number>(currentPage);
  const [, setMetadataModalOpen] = useState(false);
  const [, setSelectedMetadata] = useState("");
  const [loading, setLoading] = useState(true);
  const [filterApplied, setFilterApplied] = useState(false);
  const [showUserTab, setShowUserTab] = useState(false);
  const [openMatchIDDropdown, setOpenMatchIDDropdown] = useState(false);
  const [showCopySuccess, setShowCopySuccess] = useState<string | null>(null);
  const [failureMessage, setFailureMessage] = useState("");
  const [refreshIn, setRefreshIn] = useState(15);
  const [autoRefreshPaused, setAutoRefreshPaused] = useState(false);
  const [emptyPage, setEmptyPage] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [filterMatchId, setfilterMatchId] = useState("");
  const filterMatchIdRef = useRef(filterMatchId);
  const campaignNameRef = useRef(campaignName);
  const [filterQueryId, setFilterQueryId] = useState(undefined);
  const filterQueryIdRef = useRef(filterQueryId);
  const [filterStartDate, setFilterStartDate] = useState<any>(undefined);
  const [filterEndDate, setFilterEndDate] = useState<any>(undefined);
  const FilterStartDateRef = useRef(filterStartDate);
  const FilterEndDateRef = useRef(filterEndDate);
  const lastKeyRef = useRef<{index_forward: boolean, last_index: string | undefined} | undefined>(undefined);
  const reloadInProgressRef = useRef(false);
  const refreshCountRef = useRef(15);
  const [columnWidths, setColumnWidths] = useState({
    1: "250px",
    2: "200px",
    3: "220px",
    4: "100px",
    5: "220px",
    6: "250px",
    7: "260px",
  });
  const [activeErrorRow, setActiveErrorRow] = useState<string | null>(null);
  const [activeTechErrorRow, setActiveTechErrorRow] = useState<string | null>(null);
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [statusFilter, setStatusFilter] = useState<string | null>(null);
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const resizingRef = useRef({ index: null, startX: null, startWidth: null });
  const maxFirstColumnWidth = 600;
  const rowsPerPage = 8;
  const userRole = localStorage.getItem("userRole");
  const sessionFederationId =
    localStorage.getItem("federationkey") === "null"
      ? null
      : localStorage.getItem("federationkey");
  var sessionOrgId = localStorage.getItem("organizationkey");
  const getOrgByFederationIDFn = useAsyncFn({
    promiseFn: getOrgByFederationID,
    federationID: sessionFederationId,
  });
  const fedSpecificMenuLabels = JSON.parse(
    localStorage.getItem("fedSpecificMenuLabels") || "{}",
  );

  const getConfigFn = useAsyncFn({
    deferFn: getConfig,
    organizationId: sessionOrgId,
  });

  useEffect(() => {
    if (sessionOrgId) {
      getConfigFn
        .run({ organizationId: sessionOrgId })
        .catch((err) => {
          console.error("Handled gracefully:", err);
        });
    }
  }, [sessionOrgId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);

  useEffect(() => {
    filterMatchIdRef.current = filterMatchId;
  }, [filterMatchId]);

  useEffect(() => {
    campaignNameRef.current = campaignName;
  }, [campaignName]);

  useEffect(() => {
    filterQueryIdRef.current = filterQueryId;
  }, [filterQueryId]);

  useEffect(() => {
    FilterEndDateRef.current = filterEndDate;
  }, [filterEndDate]);

  useEffect(() => {
    FilterStartDateRef.current = filterStartDate;
  }, [filterStartDate]);

  var allIdentifiers =
    getConfigFn.data?.message?.canonical_identity_types ?? [];

  const identityTypeMap = new Map<string, string>(
    (allIdentifiers || []).map(({ key, value }) => [key, value]),
  );

  const history = useHistory();
  const params = useParams();
  var path_queryId = params.id;

  useEffect(() => {
    setFilterQueryId(filter_query || path_queryId);
  }, [filter_query, path_queryId]);

  var filterEventType: any = filterEventName;
  var filterOrg: any = filterOrgName;
  const { mainMenuItems, setActiveSubItem, setIsSideBarMenuDisabled } =
    useSidebar();

  const toggleRow = (index: number) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleMouseDown = (e, index) => {
    e.preventDefault();

    document.body.style.userSelect = "none";
    resizingRef.current = {
      index,
      startX: e.clientX,
      startWidth: parseInt(columnWidths[index], 10),
    };
    document.body.classList.add("no-select");
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    const { index, startX, startWidth } = resizingRef.current;
    if (index !== null) {
      const deltaX = e.clientX - startX;
      let newWidth = Math.max(50, startWidth + deltaX);

      setColumnWidths((prev) => ({
        ...prev,
        [index]: `${newWidth}px`,
      }));
    }
  };

  const handleMouseUp = () => {
    resizingRef.current = { index: null, startX: null, startWidth: null };
    document.body.style.userSelect = "";
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
    document.body.classList.remove("no-select");
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const interval = setInterval(() => {
      if (
        openSearchMetadataModal ||
        datePickerOpen ||
        autoRefreshPaused ||
        openMatchIDDropdown ||
        activeErrorRow !== null ||
        activeTechErrorRow !== null
      )
        return;

      if (reloadInProgressRef.current) return;

      refreshCountRef.current -= 1;
      setRefreshIn(refreshCountRef.current);

      if (refreshCountRef.current <= 0) {
        reloadInProgressRef.current = true;
        reloadHistory().finally(() => {
          reloadInProgressRef.current = false;
          refreshCountRef.current = 15;
          setRefreshIn(15);
        });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [ // eslint-disable-line react-hooks/exhaustive-deps
    openSearchMetadataModal,
    datePickerOpen,
    autoRefreshPaused,
    openMatchIDDropdown,
    activeErrorRow,
    activeTechErrorRow,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (searchParams.get("queryid")) {
          await getQueriesFn.run({
            deferFn: getmatchratequery,
            page_size: rowsPerPage,
            scan_index_forward: false,
            federationId: sessionFederationId,
            organizationId: sessionOrgId,
            target: showUserTab,
            role: userRole,
            query_id: searchParams.get("queryid"),
          });
        } else await getQueriesFn.run();
      } catch (error) {
        if (error?.response?.status === 503) {
          setFailureMessage(
            "Service is temporarily unavailable. Please try again later.",
          );
        } else {
          setFailureMessage(
            "Something went wrong. Please refresh and try again.",
          );
        }
      }
    };

    fetchData();
    const sideBarMenuToHighlight = mainMenuItems
      .flatMap((item) => item.subMenu)
      .find((subItem) =>
        subItem.urls.some((url) => url.includes("/activation-history")),
      )?.label;

    setActiveSubItem(sideBarMenuToHighlight);
    setIsSideBarMenuDisabled({
      fed: false,
      cp: sessionFederationId === null ? true : false,
      cr: sessionFederationId === null ? true : false,
      pr: sessionFederationId === null ? true : false,
      ca: false,
      ah: sessionFederationId === null ? true : false,
      dm: sessionFederationId === null ? true : false,
    });
    setBreadcrumbItems([
      { label: "Discover", path: "/entry-hub?console=Discover" },
      { label: "Curation", path: "/federation-selection" },
      { label: "Federation Selection", path: "/federation-selection" },
      {
        label:
          fedSpecificMenuLabels?.campaign_history ||
          fedSpecificMenuLabels?.camapaign_history ||
          "Campaign History",
        path: "/activation-history",
      },
    ]);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOpenModal = (row) => {
    setSelectedMetadata(row);
    setMetadataModalOpen(true);
  };
  const getQueriesFn = useAsyncFn({
    deferFn: getmatchratequery,
    page_size: rowsPerPage,
    scan_index_forward: false,
    federationId: sessionFederationId,
    organizationId: sessionOrgId,
    target: showUserTab,
    role: userRole,
  });
  const getActivationHistoryExportFn = useAsyncFn({
    deferFn: getActivationHistoryExport,
    page_size: rowsPerPage,
    scan_index_forward: false,
    federationId: sessionFederationId,
    organizationId: sessionOrgId,
    target: showUserTab,
    role: userRole,
  });

  const downloadReport = async ({ fileFormat }) => {
    try {
      const res = await getActivationHistoryExportFn.run({
        deferFn: getActivationHistoryExport,
        federationId: sessionFederationId,
        organizationId: sessionOrgId,
        target: showUserTab,
        role: userRole,
        file_format: fileFormat,
      });

      const formatTimestamp = () => {
        const now = new Date();
        const day = now.getDate().toString().padStart(2, "0");
        const month = now.toLocaleString("default", { month: "short" });
        const year = now.getFullYear().toString().slice(-2);
        let hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${day}${month}${year}_${hours}.${minutes}${ampm}`;
      };

      if (!res.ok) {
        let errorText;
        try {
          errorText = await res.text();
        } catch (parseErr) {
          errorText = "[Unable to read error body]";
        }
        console.error("Status:", res.status);
        console.error("Response body:", errorText);
        throw new Error(`Download failed with status ${res.status}`);
      }

      const blob = await res.blob();

      const contentDisposition = res.headers.get("content-disposition");
      const timestamp = formatTimestamp();
      const safeName =
        localStorage.getItem("federationname")?.replace(/\s+/g, "_") ||
        "Unknown";
      let filename = `CampaignHistory_${safeName}_${timestamp}.${fileFormat}`;
      if (contentDisposition?.includes("filename=")) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) filename = match[1];
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(`Error downloading ${fileFormat}:`, err);
    }
  };

  const reloadHistory = async () => {
    setLoading(true);

    try {
      const response = await getQueriesFn.run({
        promiseFn: getmatchratequery,
        page_size: rowsPerPage,
        scan_index_forward: currentPageRef.current === 1? false : lastKeyRef.current ? lastKeyRef.current.index_forward : false,
        federationId: sessionFederationId,
        organizationId: sessionOrgId,
        target: showUserTab,
        role: userRole,
        query_id: searchParams.get("queryid") || filterQueryIdRef?.current,
        start_date: FilterStartDateRef.current
          ? formatTimestamp(new Date(FilterStartDateRef.current).toISOString())
          : undefined,
        last_key: currentPageRef.current === 1 ? FilterEndDateRef.current
          ? formatTimestamp(new Date(FilterEndDateRef.current).toISOString())
          : undefined : lastKeyRef.current ? formatTimestamp(new Date(lastKeyRef.current.last_index).toISOString()) : undefined,
        campaign_name: campaignNameRef.current,
        Identifier: filterMatchIdRef.current,
      });

      if (response?.Items) {
        setTableData(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  const ClearFilters = async () => {
    setFilterQueryId(undefined);
    filterQueryIdRef.current = undefined;
    setFilterValue({});
    setFilterApplied(false);
    FilterStartDateRef.current = null;
    FilterEndDateRef.current = null;
    setFilterStartDate(undefined);
    setFilterEndDate(undefined);
    setCampaignName("");
    campaignNameRef.current = "";
    setfilterMatchId("");
    filterMatchIdRef.current = "";
    currentPageRef.current = 1;
    setCurrentPage(1);
    lastKeyRef.current = undefined;
    setSortColumn(null);
    setSortDirection("asc");
    try {
      const response = await getQueriesFn.run({
        promiseFn: getmatchratequery,
        page_size: rowsPerPage,
        scan_index_forward: false,
        federationId: sessionFederationId,
        organizationId: sessionOrgId,
        target: showUserTab,
        role: userRole,
        query_id: undefined,
      });

      if (response?.Items) {
        setTableData(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const removeFilter = async (key: string) => {
    const next = { ...filterValue };
    delete next[key];
    setFilterValue(next);
    if (!Object.keys(next).length) setFilterApplied(false);

    if (key === "Query" || key === "Campaign") {
      setFilterQueryId(undefined);
      setCampaignName("");
    }
    if (key === "ID Type") setfilterMatchId("");
    if (key === "Updated At") {
      FilterStartDateRef.current = null;
      FilterEndDateRef.current = null;
      setFilterStartDate(undefined);
      setFilterEndDate(undefined);
    }

    try {
      const response = await getQueriesFn.run({
        promiseFn: getmatchratequery,
        page_size: rowsPerPage,
        scan_index_forward: false,
        federationId: sessionFederationId,
        organizationId: sessionOrgId,
        target: showUserTab,
        role: userRole,
        query_id: (key === "Query" || key === "Campaign") ? undefined : filterQueryIdRef.current,
        campaign_name: key === "Campaign" ? undefined : campaignName || undefined,
        Identifier: key === "ID Type" ? undefined : filterMatchIdRef.current || undefined,
        start_date: key === "Updated At" || !FilterStartDateRef.current ? undefined
          : formatTimestamp(new Date(FilterStartDateRef.current).toISOString()),
        last_key: key === "Updated At" || !FilterEndDateRef.current ? undefined
          : formatTimestamp(new Date(FilterEndDateRef.current).toISOString()),
      });
      if (response?.Items) setTableData(response);
      currentPageRef.current = 1;
      setCurrentPage(1);
      lastKeyRef.current = undefined;
    } catch (err) {
      console.error("Error removing filter:", err);
    }
  };

  const toggleAllRows = () => {
    const allExp = tableData?.Items?.length > 0 &&
      tableData.Items.every((_: any, i: number) => expandedRows[i]);
    if (allExp) {
      setExpandedRows({});
    } else {
      const all: Record<number, boolean> = {};
      (tableData?.Items ?? []).forEach((_: any, i: number) => { all[i] = true; });
      setExpandedRows(all);
    }
  };

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection((d) => (d === "asc" ? "desc" : "asc"));
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const handleStatusFilter = (status: string) => {
    setStatusFilter((prev) => (prev === status ? null : status));
  };

  const filterText = useMemo(() => {
    let filters = "";
    for (const key in filterValue) {
      filters = (filters && filters + " | ") + `${key}: ${filterValue[key]}`;
    }
    return filters;
  }, [filterValue]);

  const handleMetadataFilter = async (value) => {
    setFilterApplied(true);
    var campaignName;

    const isQueryId = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i.test(
      value,
    );
    var filterQueryId1;
    if (isQueryId) {
      setFilterQueryId(value);
      filterQueryId1 = value;
    } else {
      campaignName = value;
      setCampaignName(value);
    }
    const tempFilterVal = { ...filterValue };
    delete tempFilterVal["Query"];
    delete tempFilterVal["Campaign"];
    setFilterValue({
      ...tempFilterVal,
      ...(isQueryId ? { Query: value } : { Campaign: value }),
    });
    try {
      const response = await getQueriesFn.run({
        promiseFn: getmatchratequery,
        offset: 0,
        limit: rowsPerPage,
        federationId: sessionFederationId,
        organizationId: filterOrg || sessionOrgId,
        event: filterEventType,
        ...(filterQueryId1 && { query_id: value }),
        target: showUserTab,
        role: userRole,
        ...(campaignName && { campaign_name: campaignName }),
        start_date: FilterStartDateRef.current
          ? formatTimestamp(new Date(FilterStartDateRef.current).toISOString())
          : undefined,
        last_key: FilterEndDateRef.current
          ? formatTimestamp(new Date(FilterEndDateRef.current).toISOString())
          : undefined,
        Identifier: filterMatchIdRef.current,
      });

      if (response?.Items) {
        setTableData(response);
      }
      currentPageRef.current = 1;
      setCurrentPage(1);
      lastKeyRef.current = undefined;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [tableData, setTableData] = useState(getQueriesFn.data);

  const statusCounts = useMemo(() => {
    const items = tableData?.Items ?? [];
    if (!items.length) return null;
    const counts = { error: 0, incomplete: 0, processing: 0, succeeded: 0, total: items.length };
    items.forEach((row: any) => {
      if (hasStaleProcessing(row)) {
        counts.error++;
      } else if (hasProcessingStatus(row)) {
        counts.processing++;
      } else if (Object.values(row.all_result_transfer || {}).some((item: any) => item.status?.toUpperCase() === "ERROR")) {
        counts.error++;
      } else {
        const pct = row?.result_transfer?.percentage ?? 0;
        if (pct === 100) counts.succeeded++;
        else if (pct > 0) counts.incomplete++;
        else counts.error++;
      }
    });
    return counts;
  }, [tableData?.Items]); // eslint-disable-line react-hooks/exhaustive-deps

  const allExpanded = (tableData?.Items?.length ?? 0) > 0 &&
    (tableData?.Items ?? []).every((_: any, i: number) => expandedRows[i]);

  const sortedFilteredItems = useMemo(() => {
    const items = tableData?.Items ?? [];
    if (!items.length) return items;

    let result = [...items];

    if (statusFilter) {
      result = result.filter((row: any) => {
        if (hasStaleProcessing(row)) return statusFilter === "error";
        if (hasProcessingStatus(row)) return statusFilter === "processing";
        if (Object.values(row.all_result_transfer || {}).some((item: any) => item.status?.toUpperCase() === "ERROR")) return statusFilter === "error";
        const pct = row?.result_transfer?.percentage ?? 0;
        if (pct === 100) return statusFilter === "succeeded";
        if (pct > 0 && pct < 100) return statusFilter === "incomplete";
        return statusFilter === "error";
      });
    }

    if (sortColumn) {
      result.sort((a: any, b: any) => {
        let va: number, vb: number;
        if (sortColumn === "percentage") {
          va = a.result_transfer?.percentage ?? 0;
          vb = b.result_transfer?.percentage ?? 0;
        } else if (sortColumn === "status") {
          const order: Record<string, number> = { error: 0, incomplete: 1, processing: 2, succeeded: 3 };
          const rank = (row: any) => {
            if (hasStaleProcessing(row)) return order.error;
            if (hasProcessingStatus(row)) return order.processing;
            if (Object.values(row.all_result_transfer || {}).some((i: any) => i.status?.toUpperCase() === "ERROR")) return order.error;
            const pct = row?.result_transfer?.percentage ?? 0;
            if (pct === 100) return order.succeeded;
            if (pct > 0) return order.incomplete;
            return order.error;
          };
          va = rank(a); vb = rank(b);
        } else {
          va = new Date(a.last_transfer_update_at || a.updated_at || a.created_at).getTime();
          vb = new Date(b.last_transfer_update_at || b.updated_at || b.created_at).getTime();
        }
        return sortDirection === "asc" ? va - vb : vb - va;
      });
    }

    return result;
  }, [tableData?.Items, sortColumn, sortDirection, statusFilter]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (getQueriesFn?.data?.Items?.length) {
      setEmptyPage(false);
      setTableData(getQueriesFn?.data);
      setLoading(false);
    } else if (getQueriesFn?.data) {
      setEmptyPage(true);
      setTableData(getQueriesFn?.data);
      setLoading(false);
    }
  }, [getQueriesFn?.data]);
  const getTargetQueriesFn = useAsyncFn({
    deferFn: getmatchratequery,
    page_size: rowsPerPage,
    scan_index_forward: false,
    federationId: sessionFederationId,
    organizationId: sessionOrgId,
    target: true,
    role: userRole,
  });

  function isStaleProcessing(timestamp: string | Date | undefined): boolean {
    if (!timestamp) return false;
    return Date.now() - new Date(timestamp).getTime() > THREE_DAYS_MS;
  }

  function hasProcessingStatus(row: any): boolean {
    const transfers = row.all_result_transfer;
    if (!transfers || typeof transfers !== "object") return false;

    const values = Object.values(transfers);

    if (
      values.some((item: any) =>
        ["PROCESSING", "STARTED"].includes(item.status?.toUpperCase()),
      )
    ) {
      return true;
    }

    if (values.some((item: any) => item.status?.toUpperCase() === "ERROR")) {
      return false;
    }
    return false;
  }

  function hasStaleProcessing(row: any): boolean {
    const transfers = row.all_result_transfer;
    if (!transfers || typeof transfers !== "object") return false;
    return Object.values(transfers).some((item: any) => {
      if (!["PROCESSING", "STARTED"].includes(item.status?.toUpperCase())) return false;
      const ts = item.last_transfer_update_at || item.updated_at || item.created_at;
      return isStaleProcessing(ts);
    });
  }

  const getStatusIcon = (row) => {
    if (hasStaleProcessing(row)) return IncompleteIcon;
    if (hasProcessingStatus(row)) return RunningIcon;
    const percent = row?.result_transfer?.percentage;
    if (percent === 100) return DoneIcon;
    if (percent > 0 && percent < 100) return IncompleteIcon;
    if (
      row.all_result_transfer &&
      Object.values(row.all_result_transfer).some(
        (item: any) => item.status?.toUpperCase() === "ERROR",
      )
    ) {
      return RedInfo;
    }
    return DeletedIcon;
  };

  const getChildStatusIcon = (row) => {
    if (["STARTED", "PROCESSING"].includes(row?.status?.toUpperCase())) {
      const ts = row.last_transfer_update_at || row.updated_at || row.created_at;
      if (isStaleProcessing(ts)) return StaleIcon;
      return RunningIcon;
    }
    const percent = row?.percentage;
    if (row?.status === "ERROR" && (row?.ui_error || row?.error)) return RedInfo;
    if (percent === 100) return DoneIcon;
    if (percent > 0 && percent < 100) return IncompleteIcon;
    return DeletedIcon;
  };

  const getChildStatusTitle = (row) => {
    if (["STARTED", "PROCESSING"].includes(row?.status?.toUpperCase())) {
      const ts = row.last_transfer_update_at || row.updated_at || row.created_at;
      if (isStaleProcessing(ts)) return "Stale — processing over 3 days";
      return "Processing!";
    }
    const percent = row?.percentage;
    if (row?.status === "ERROR") return "Error!";
    if (percent === 100) return "Succeeded!";
    if (percent > 0 && percent < 100) return "Incomplete!";
    return "Failed!";
  };

  const getChildErrorInfo = (row) => {
    if (row?.status === "ERROR" && (row?.ui_error || row?.error)) {
      return row?.ui_error || row?.error;
    }
  };

  const getStatusTitle = (row) => {
    if (hasStaleProcessing(row)) return "Stale — processing over 3 days";
    if (hasProcessingStatus(row)) return "Processing!";
    const percent = row?.result_transfer?.percentage;
    if (percent === 100) return "Succeeded!";
    if (percent > 0 && percent < 100) return "Incomplete!";
    if (
      row.all_result_transfer &&
      Object.values(row.all_result_transfer).some(
        (item: any) => item.status?.toUpperCase() === "ERROR",
      )
    ) {
      return "Incomplete!";
    }
    return "Failed!";
  };

  const getSelectedMatchID = async (value) => {
    setOpenMatchIDDropdown(false); // FIX: close dropdown after selection
    setFilterApplied(true);
    setfilterMatchId(value);
    setFilterValue({ ...filterValue, "ID Type": identityTypeMap.get(value) ?? value });
    try {
      const response = await getQueriesFn.run({
        promiseFn: getmatchratequery,
        federationId: sessionFederationId,
        organizationId: sessionOrgId,
        Identifier: value,
        page_size: rowsPerPage,
        target: showUserTab,
        role: userRole,
        query_id: searchParams.get("queryid") || filterQueryIdRef?.current,
        start_date: FilterStartDateRef.current
          ? formatTimestamp(new Date(FilterStartDateRef.current).toISOString())
          : undefined,
        last_key: FilterEndDateRef.current
          ? formatTimestamp(new Date(FilterEndDateRef.current).toISOString())
          : undefined,
        campaign_name: campaignName,
      });

      if (response?.Items) {
        setTableData(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const copyToClipboard = (text, rowId: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setShowCopySuccess(rowId);

      setTimeout(() => {
        setShowCopySuccess(null);
      }, 2000);
    });
  };
  const navigateToProvTrailsPage = (queryId) => {
    if (queryId) history.push(`/provenance-record?queryid=${queryId}`);
  };

  useEffect(() => {
    if (
      getQueriesFn.error ||
      getTargetQueriesFn.error ||
      getOrgByFederationIDFn.error ||
      getConfigFn.error
    ) {
      setFailureMessage("Something went wrong. Please try again later.");
    }
  }, [
    getQueriesFn.error,
    getTargetQueriesFn.error,
    getOrgByFederationIDFn.error,
    getConfigFn.error,
  ]);
  useEffect(() => {
    if (showUserTab) setTableData(getTargetQueriesFn?.data);
  }, [getTargetQueriesFn?.data, showUserTab]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (searchParams.get("queryid")) {
          await getQueriesFn.run({
            deferFn: getmatchratequery,
            page_size: rowsPerPage,
            scan_index_forward: false,
            federationId: sessionFederationId,
            organizationId: sessionOrgId,
            target: showUserTab,
            role: userRole,
            query_id: searchParams.get("queryid"),
          });
        } else await getQueriesFn.run();
      } catch (error) {
        if (error?.response?.status === 503) {
          setFailureMessage(
            "Service is temporarily unavailable. Please try again later.",
          );
        } else {
          setFailureMessage(
            "Something went wrong. Please refresh and try again.",
          );
        }
      }
    };

    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const tableContainer = document.querySelector(
      `.${styles.container}`,
    ) as HTMLElement;
    if (tableContainer) {
      tableContainer.style.minHeight =
        openEventTypeDropdown || openParticipantsDropdown ? "300px" : "";
    }
  }, [openEventTypeDropdown, openParticipantsDropdown]);

  const HandleTimestamp = async (startDate, endDate) => {
    setFilterApplied(true);
  
    FilterStartDateRef.current = new Date(startDate).getTime();
    FilterEndDateRef.current = new Date(endDate).getTime();
    setFilterStartDate(FilterStartDateRef.current);
    setFilterEndDate(FilterEndDateRef.current);
    const response = await getQueriesFn.run({
      promiseFn: getmatchratequery,
      offset: 0,
      limit: rowsPerPage,
      federationId: sessionFederationId,
      organizationId: sessionOrgId,
      event: filterEventType,
      target: showUserTab,
      role: userRole,
      query_id: searchParams.get("queryid") || filterQueryId,
      start_date: FilterStartDateRef.current
        ? formatTimestamp(new Date(FilterStartDateRef.current).toISOString())
        : undefined,
      last_key: FilterEndDateRef.current
        ? formatTimestamp(new Date(FilterEndDateRef.current).toISOString())
        : undefined,
      campaign_name: campaignName,
      Identifier: filterMatchIdRef.current,
      page_size: rowsPerPage,
    });
    setFilterValue({
      ...filterValue,
      "Updated At": `From ${formatDateForChip(startDate)} to ${formatDateForChip(endDate)}`,
    });
    if (response?.Items) {
      setTableData(response);
    }
    currentPageRef.current = 1;
    setCurrentPage(1);
    lastKeyRef.current = undefined;
  };

  const handlePreviousPageClick = async () => {
    if (currentPage === 1) {
      showToast('You are already on the first page.', 'info');
      return;
    }
    if (
      currentPage - 1 === visiblePages[visiblePages?.length - 1] &&
      currentPage < 10
    ) {
      setVisiblePages([...visiblePages, currentPage + 1]);
    } else if (currentPage - 1 === visiblePages[0] && currentPage - 1 > 1) {
      setVisiblePages([currentPage - 2, ...visiblePages]);
    }
    const response = await getQueriesFn.run({
      promiseFn: getmatchratequery,
      limit: rowsPerPage,
      federationId: sessionFederationId,
      organizationId: sessionOrgId,
      page_size: rowsPerPage,
      scan_index_forward: emptyPage ? false : true,
      target: showUserTab,
      start_date: FilterStartDateRef.current
      ? formatTimestamp(new Date(FilterStartDateRef.current).toISOString())
      : undefined,
      last_key: emptyPage ? undefined : formatTimestamp(tableData?.Items[0]?.last_transfer_update_at || tableData?.Items[0]?.created_at),
      role: userRole,
      offset: calculateOffset(currentPage - 1, 8),
    });

    if (response?.Items) {
      setTableData(response);
    }
    lastKeyRef.current = {index_forward: true, last_index: emptyPage ? undefined : tableData?.Items[0]?.last_transfer_update_at || tableData?.Items[0]?.created_at || undefined };
    setCurrentPage(currentPage-1);
  };

  const formatTimestamp = (timestamp) => {
    return timestamp.replace(/\.000Z$/, "Z");
  };

  const formatDateForChip = (dateStr: string): string => formatDateTime(dateStr);

  const handleNextPageClick = async () => {
    if (!tableData?.Items?.length) return;
    const lastDataIndex = tableData.Items.length - 1;

    const response = await getQueriesFn.run({
      promiseFn: getmatchratequery,
      limit: rowsPerPage,
      offset: calculateOffset(currentPage + 1, 8),
      federationId: sessionFederationId,
      organizationId: sessionOrgId,
      page_size: rowsPerPage,
      scan_index_forward: false,
      target: showUserTab,
      role: userRole,
      start_date: FilterStartDateRef.current
        ? formatTimestamp(new Date(FilterStartDateRef.current).toISOString())
      : undefined,
      last_key: formatTimestamp(tableData?.Items[Number(lastDataIndex)]?.last_transfer_update_at || tableData?.Items[Number(lastDataIndex)]?.created_at) || undefined,
      query_id: filterQueryId,
      campaign_name: campaignName,
      Identifier: filterMatchId,
    });

    if (!response?.Items?.length) {
      showToast('No more data to display.', 'info');
      return;
    }

    setTableData(response);
    setCurrentPage(currentPage + 1);
    lastKeyRef.current = {index_forward: false, last_index: tableData?.Items[Number(lastDataIndex)]?.last_transfer_update_at || tableData?.Items[Number(lastDataIndex)]?.created_at || undefined};
  };

  const calculateOffset = (page, pageSize = 8): number => {
    return (page - 1) * pageSize;
  };

  const storedPermissions = JSON.parse(
    localStorage.getItem("userPermissions") || "{}",
  );

  return storedPermissions?.activationhistory === "no" ? (
    <PageNotFound />
  ) : (
    <LayoutContainer>
      <div className={styles.pageRoot}>
      <div className={styles.actionsBar}>
        <button
          className={styles.backButton}
          onClick={() => history.push("federation-selection")}
        >
          <img src={SimpleBackIcon} alt="back" />
          <span className={styles.backButtonText}>Back</span>
        </button>
        <div className={styles.infoContainer}>
          <InforIcon
            className={styles.headerInfoIcon}
            onClick={() => setShowInfoPopup(true)}
          />
          {showInfoPopup && (
            <InfoPopup
              isOpen={showInfoPopup}
              onClose={() => setShowInfoPopup(false)}
              closeButtonLabel="Got it"
              headerText="Campaign History"
              freeText
            >
              <div style={{ textAlign: "left", fontSize: "13px", lineHeight: "1.65", color: "var(--active-bg-color)", padding: "0 4px" }}>
                <p style={{ marginBottom: "16px", color: "#3a4a62" }}>
                  Tracks the delivery status of audience data transfers across your federation. Each row is one campaign run — expand it to see the breakdown per ad server.
                </p>

                <p className={styles.infoSectionLabel}>Tabs</p>
                <p className={styles.infoSectionText}><strong>Initiated</strong> — Transfers your organisation sent to ad servers or cloud & storage providers.</p>
                <p className={styles.infoSectionTextSpaced}><strong>Target</strong> — Transfers your organisation received from another federation participant.</p>

                <p style={{ fontWeight: 700, fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.09em", color: "#5c6d85", marginBottom: "8px" }}>Status Icons</p>
                <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginBottom: "16px" }}>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <span style={{ color: "var(--Primary-Color-Shade-1)", fontWeight: 700, minWidth: "18px", textAlign: "center" }}>↻</span>
                    <span><strong>Processing</strong> — Transfer is actively running.</span>
                  </div>
                  <div className={styles.infoStatusItem}>
                    <span style={{ color: "#1a7a4a", fontWeight: 700, minWidth: "18px", textAlign: "center" }}>✓</span>
                    <span><strong>Succeeded</strong> — 100% of audience IDs delivered to the ad server.</span>
                  </div>
                  <div className={styles.infoStatusItem}>
                    <span style={{ color: "#b06000", fontWeight: 700, minWidth: "18px", textAlign: "center" }}>◑</span>
                    <span><strong>Incomplete</strong> — Partial delivery; transfer may still be progressing.</span>
                  </div>
                  <div className={styles.infoStatusItem}>
                    <span style={{ color: "#bf3a2b", fontWeight: 700, minWidth: "18px", textAlign: "center" }}>!</span>
                    <span><strong>Error</strong> — Transfer failed. Expand the row and click the red icon on the affected ad server for details.</span>
                  </div>
                  <div className={styles.infoStatusItem}>
                    <span style={{ color: "#bf3a2b", fontWeight: 700, minWidth: "18px", textAlign: "center" }}>!</span>
                    <span><strong>Stale</strong> — Processing for over 3 days with no progress. Requires investigation.</span>
                  </div>
                  <div className={styles.infoStatusItem}>
                    <span style={{ color: "#9ca3af", fontWeight: 700, minWidth: "18px", textAlign: "center" }}>✕</span>
                    <span><strong>Failed</strong> — 0% delivered; transfer did not complete.</span>
                  </div>
                </div>

                <p className={styles.infoSectionLabel}>Columns</p>
                <p className={styles.infoSectionText}><strong>Transfer % | Total transfers</strong> — Percentage of the target audience reached, plus total transfers attempted</p>
                <p className={styles.infoSectionText}><strong>ID Type</strong> — Identifier format used for audience matching (e.g. hashed email, GAID). Use the dropdown to filter by type.</p>
                <p className={styles.infoSectionTextSpaced}><strong>Updated At</strong> — When the transfer last reported progress.</p>

                <div className={styles.infoCallout}>
                  <p className={styles.infoSectionLabel}>Quick Actions</p>
                  <ul className={styles.infoList}>
                    <li>Click a status chip in the summary bar to filter the view.</li>
                    <li>Click ↕ on Transfer %, Status, or Updated At to sort.</li>
                    <li>Expand a row to see per-ad-server delivery details and record counts.</li>
                    <li>Click the chain icon next to a cohort name to view its blockchain audit trail.</li>
                    <li>Pause auto-refresh with the pause button while investigating an issue.</li>
                    <li>Export downloads all records — active filters do not affect the export.</li>
                  </ul>
                </div>
              </div>
            </InfoPopup>
          )}
        </div>
      </div>

      {!tableData?.Items?.length && !filterApplied && !loading ? (
        <NoData {...(failureMessage ? { message: failureMessage } : {})} />
      ) : (
        <div
          className={styles.container}
          style={
            {
              "--initiated-tab-bg-color": showUserTab ? "white" : "var(--Primary-Color-Shade-1-pale, #e5f6fc)",
              "--target-tab-bg-color": showUserTab ? "var(--Primary-Color-Shade-1-pale, #e5f6fc)" : "white",
            } as React.CSSProperties
          }
        >
          <div className={styles.tableControls}>
            <div className={styles.tabContainer} role="tablist" aria-label="Campaign view">
              <button
                role="tab"
                aria-selected={!showUserTab}
                className={`${styles.initiated} ${!showUserTab ? styles.tabActive : ""}`}
                onClick={() => {
                  setShowUserTab(false);
                  setFilterApplied(true);
                  getQueriesFn.run({
                    promiseFn: getmatchratequery,
                    page_size: rowsPerPage,
                    scan_index_forward: false,
                    federationId: sessionFederationId,
                    organizationId: sessionOrgId,
                    target: false,
                    role: userRole,
                  });
                }}
              >
                Initiated
              </button>
              <button
                role="tab"
                aria-selected={showUserTab}
                className={`${styles.target} ${showUserTab ? styles.tabActive : ""}`}
                onClick={() => {
                  setShowUserTab(true);
                  setTableData(getTargetQueriesFn?.data);
                  getTargetQueriesFn.run();
                  setFilterApplied(true);
                }}
              >
                Target
              </button>
            </div>
            <span className={styles.filterDetailsContainer}>
              {Object.entries(filterValue).map(([key, val]) => (
                <span key={key} className={styles.filterChip}>
                  <strong>{key}:</strong>&nbsp;{String(val)}
                  <button
                    type="button"
                    className={styles.filterChipRemove}
                    onClick={() => removeFilter(key)}
                    aria-label={`Remove ${key} filter`}
                  >
                    ✕
                  </button>
                </span>
              ))}
            </span>
            <div className={styles.filtersContainer}>
              <DownloadButton
                element_color={getCSSVariable("--Primary-Color-Shade-1")}
                downloadCSV={() => downloadReport({ fileFormat: "csv" })}
                downloadJSON={() => {}}
                downloadPDF={() => downloadReport({ fileFormat: "pdf" })}
                showJson={false}
              />
              {openSearchMetadataModal ||
              datePickerOpen ||
              autoRefreshPaused ||
              activeErrorRow !== null ||
              activeTechErrorRow !== null ? (
                <div className={styles.refreshTimer}>Auto-refresh paused</div>
              ) : (
                <div className={styles.refreshTimer}>
                  Auto-refreshing in: <strong>{refreshIn}s</strong>
                </div>
              )}
              {autoRefreshPaused ? (
                <Tooltip text="Resume Auto-refresh" placement="top">
                  <PlayIcon
                    onClick={() => setAutoRefreshPaused(false)}
                    className={styles.primaryColor}
                  />
                </Tooltip>
              ) : (
                <Tooltip text="Pause Auto-refresh" placement="top">
                  <PauseIcon
                    onClick={() => setAutoRefreshPaused(true)}
                    className={styles.primaryColor}
                  />
                </Tooltip>
              )}
              <span
                className={styles.expandCollapseBtn}
                onClick={toggleAllRows}
              >
                {allExpanded ? "Collapse All" : "Expand All"}
              </span>
              <span
                className={styles.clearFilters}
                onClick={ClearFilters}
              >
                Clear Filters
              </span>
              <span
                className={styles.reload}
                onClick={reloadHistory}
              >
                Reload
              </span>
            </div>
          </div>
          <div className={styles.tableWrapper}>
            {loading && (
              <TableShimmer rows={8} columnWidths={[3, 2, 5, 1, 4]} />
            )}
            {!loading && <table className={styles.table}>
              <thead>
                <tr>
                  <th></th>
                  <th
                    style={{
                      width:
                        Math.min(
                          parseInt(columnWidths[1], 10),
                          maxFirstColumnWidth,
                        ) + "px",
                      maxWidth: maxFirstColumnWidth + "px",
                    }}
                    className={styles.resizableHeader}
                  >
                    <ColHeader
                      label="Cohort Name | Query ID"
                      icon={<MdDescription />}
                      actionsAlign="right"
                    >
                      <FilterIcon
                        className={styles.icon}
                        onClick={() => setOpenMetadataModal(true)}
                      />
                    </ColHeader>
                    <div
                      className={styles.resizeHandle}
                      onMouseDown={(e) => handleMouseDown(e, 1)}
                    />
                    {openSearchMetadataModal && (
                      <SearchModal
                        isOpen={openSearchMetadataModal}
                        onClose={() => setOpenMetadataModal(false)}
                        onApply={handleMetadataFilter}
                        headerText="Search Cohort"
                        placeholder="Cohort name or Query ID"
                        errorText="Please enter a cohort name or Query ID"
                      />
                    )}
                  </th>
                  <th
                    style={{
                      width:
                        Math.min(
                          parseInt(columnWidths[2], 10),
                          maxFirstColumnWidth,
                        ) + "px",
                      maxWidth: maxFirstColumnWidth + "px",
                    }}
                    className={styles.resizableHeader}
                  >
                    <ColHeader
                      label="ID Type | Ad Server"
                      icon={<MdFingerprint />}
                    >
                      <Tooltip
                        text="Shows ID Type for parent rows and Ad Server details for child rows."
                        placement="bottom"
                      >
                        <InfoIcon className={styles.infoIcon} />
                      </Tooltip>
                      <DownIcon
                        className={styles.icon}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenMatchIDDropdown(true);
                        }}
                      />
                    </ColHeader>
                    <div
                      className={styles.resizeHandle}
                      onMouseDown={(e) => handleMouseDown(e, 2)}
                    />

                    {openMatchIDDropdown && (
                      <Dropdown
                        items={allIdentifiers}
                        onSelect={getSelectedMatchID}
                        isOpen={openMatchIDDropdown}
                        onClose={() => setOpenMatchIDDropdown(false)}
                      />
                    )}
                  </th>

                  <th
                    style={{
                      width:
                        Math.min(
                          parseInt(columnWidths[3], 10),
                          maxFirstColumnWidth,
                        ) + "px",
                      maxWidth: maxFirstColumnWidth + "px",
                    }}
                    className={styles.resizableHeader}
                  >
                    <ColHeader
                      label={
                        <>
                          Transfer Percentage <br />
        
                        </>
                      }
                      icon={<MdSync />}
                    >
                      <button
                        className={styles.sortBtn}
                        onClick={() => handleSort("percentage")}
                        aria-label={`Sort by transfer percentage ${sortColumn === "percentage" ? (sortDirection === "asc" ? "descending" : "ascending") : "ascending"}`}
                      >
                        {sortColumn === "percentage" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                      </button>
                    </ColHeader>
                    <div
                      className={styles.resizeHandle}
                      onMouseDown={(e) => handleMouseDown(e, 3)}
                    />
                  </th>
                  <th
                    style={{
                      width:
                        Math.min(
                          parseInt(columnWidths[4], 10),
                          maxFirstColumnWidth,
                        ) + "px",
                      maxWidth: maxFirstColumnWidth + "px",
                    }}
                    className={styles.resizableHeader}
                  >
                    <ColHeader label="Status" icon={<MdCheckCircle />}>
                      <button
                        className={styles.sortBtn}
                        onClick={() => handleSort("status")}
                        aria-label={`Sort by status ${sortColumn === "status" ? (sortDirection === "asc" ? "descending" : "ascending") : "ascending"}`}
                      >
                        {sortColumn === "status" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                      </button>
                    </ColHeader>
                    <div
                      className={styles.resizeHandle}
                      onMouseDown={(e) => handleMouseDown(e, 4)}
                    />
                  </th>
                  <th
                    style={{
                      width:
                        Math.min(
                          parseInt(columnWidths[5], 10),
                          maxFirstColumnWidth,
                        ) + "px",
                      maxWidth: maxFirstColumnWidth + "px",
                    }}
                    className={styles.resizableHeader}
                  >
                    <ColHeader
                      label="Updated At"
                      icon={<MdCalendarToday />}
                      actionsAlign="right"
                    >
                      <button
                        className={styles.sortBtn}
                        onClick={() => handleSort("updatedAt")}
                        aria-label={`Sort by updated date ${sortColumn === "updatedAt" ? (sortDirection === "asc" ? "descending" : "ascending") : "ascending"}`}
                      >
                        {sortColumn === "updatedAt" ? (sortDirection === "asc" ? "↑" : "↓") : "↕"}
                      </button>
                      <FilterIcon
                        className={styles.icon}
                        onClick={() => setDatePickerOpen(true)}
                      />
                    </ColHeader>
                    <div
                      className={styles.resizeHandle}
                      onMouseDown={(e) => handleMouseDown(e, 5)}
                    />
                    {datePickerOpen && (
                      <DatePickerModal
                        datePickerOpen={datePickerOpen}
                        onClose={() => setDatePickerOpen(false)}
                        onApply={HandleTimestamp}
                      />
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                {!sortedFilteredItems?.length ? (
                  <tr>
                    <td colSpan={7} className={styles.noData}>
                      No records available.
                    </td>
                  </tr>
                ) : (
                  sortedFilteredItems?.map((row, index) => (
                    <React.Fragment key={row.query_id}>
                      <tr
                        key={row.query_id}
                        className={`${styles.parentRow} ${
                          expandedRows[index] ? styles.parentRowActive : ""
                        }`}
                      >
                        <td
                          className={styles.expandableRow}
                          onClick={() => toggleRow(index)}
                        >
                          <span
                            className={`${styles.expandIcon} ${
                              expandedRows[index] ? styles.expandedIcon : ""
                            }`}
                          >
                            {expandedRows[index] ? (
                              <DownIcon className={styles.downIconTransform} />
                            ) : (
                              <DownIcon />
                            )}
                          </span>
                        </td>
                        <td
                          className={styles.queryCell}
                          style={{
                            width:
                              Math.min(
                                parseInt(columnWidths[1], 10),
                                maxFirstColumnWidth,
                              ) + "px",
                            maxWidth: maxFirstColumnWidth + "px",
                          }}
                        >
                          <div className={styles.idWithIcons}>
                            <div
                              className={styles.campaignQueryCell}
                              style={{
                                width:
                                  Math.min(
                                    parseInt(columnWidths[1], 10),
                                    maxFirstColumnWidth,
                                  ) + "px",
                                maxWidth: maxFirstColumnWidth + "px",
                              }}
                            >
                              <span className={styles.campaignNameText}>
                                {row.campaign_name}
                              </span>
                              {row.audience_name && (
                                <Tooltip
                                  text={`Audience: ${row.audience_name}`}
                                  placement="bottom"
                                  maxWidth={320}
                                >
                                  <span className={styles.audienceNameText}>
                                    <MdGroups className={styles.audienceIcon} />
                                    <span className={styles.audienceNameValue}>
                                      {row.audience_name}
                                    </span>
                                  </span>
                                </Tooltip>
                              )}
                              <Tooltip
                                text={`${row.campaign_name} | ${row.id}`}
                                placement="bottom"
                                maxWidth={320}
                              >
                                <span className={styles.queryIdText}>
                                  {row.id}
                                </span>
                              </Tooltip>
                            </div>

                            <span className={styles.iconWrapper}>
                              <CopyIcon
                                className={styles.icon}
                                onClick={() =>
                                  copyToClipboard(
                                    row.id,
                                    row.id,
                                  )
                                }
                              />
                              {showCopySuccess === row.id && (
                                <span className={styles.copiedTooltip}>
                                  Copied
                                </span>
                              )}
                            </span>
                            {storedPermissions?.provenancetrail !== "no" && (
                              <Tooltip
                                text="View corresponding transactions in Blockchain"
                                className={styles.iconWrapper}
                              >
                                <TrailIcon
                                  className={`${styles.icon} ${styles.trailIconCell}`}
                                  onClick={() =>
                                    navigateToProvTrailsPage(row.id)
                                  }
                                />
                              </Tooltip>
                            )}
                          </div>
                        </td>

                        <td style={{ width: columnWidths[2] }}>
                          {identityTypeMap.get(row.canonical_identity_type) ?? row.canonical_identity_type}
                        </td>
                        <td style={{ width: columnWidths[3] }}>
                          <div className={styles.progressContainer}>
                            {(() => {
                              const transfers = Object.values(row.all_result_transfer || {}) as any[];
                              const allError =
                                transfers.length > 0 &&
                                transfers.every((item: any) => item.status?.toUpperCase() === "ERROR");
                              const parentPercentage = allError
                                ? 0
                                : row.result_transfer.percentage;
                              const succeededCount = transfers.filter(
                                (item: any) => item.percentage === 100 && item.status?.toUpperCase() !== "ERROR",
                              ).length;
                              const totalCount = transfers.length;
                              return (
                                <>
                                  <span className={styles.progressText}>
                                    {totalCount > 0 && (
                                      <>
                                        <span className={styles.transferRatioNum}>{succeededCount}</span>
                                        <span className={styles.transferRatioDivider}>/</span>
                                        <span className={styles.transferRatioTotal}>{totalCount}</span>
                                        <span className={styles.transferRatioLabel}> transfers</span>
                                        <span className={styles.transferRatioDivider}> | </span>
                                      </>
                                    )}
                                    {parentPercentage.toFixed(2)}%
                                  </span>
                                  <div className={styles.progressBar}>
                                    <div
                                      className={styles.progressFill}
                                      style={{ width: `${parentPercentage}%` }}
                                    ></div>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        </td>

                        <td style={{ width: columnWidths[4] }}>
                          <div className={styles.statusCellInner}>
                            <Tooltip text={getStatusTitle(row)} placement="top">
                              <img
                                src={getStatusIcon(row)}
                                alt="status"
                                className={styles.statusIcon}
                                onClick={() => handleOpenModal(row)}
                              />
                            </Tooltip>
                          </div>
                        </td>
                        <td style={{ width: columnWidths[5] }}>
                          {(() => {
                            const parts = formatDateTimeParts(
                              row.last_transfer_update_at || row.updated_at || row.created_at,
                            );
                            if (!parts) return <span>—</span>;
                            return (
                              <div className={styles.dateTimeCell}>
                                <span className={styles.dateText}>
                                  {parts.date}
                                </span>
                                <span className={styles.timeText}>
                                  {parts.time}
                                </span>
                              </div>
                            );
                          })()}
                        </td>
                      </tr>
                      {expandedRows[index] && (
                        <>
                          {row.all_result_transfer &&
                          Object.keys(row.all_result_transfer).length > 0 ? (
                            (() => {
                              // Extract UUID Transfer ID from the end of each key
                              const extractTid = (k: string): string | null =>
                                k.match(
                                  /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i,
                                )?.[1] ?? null;

                              // Group by Transfer ID (first-occurrence order) so same-TID rows
                              // are always contiguous — rowspan requires adjacency.
                              const groupOrder: string[] = [];
                              const groupMap = new Map<string, [string, any][]>();
                              Object.entries(row.all_result_transfer).forEach(([key, result]) => {
                                const gk = extractTid(key) ?? key;
                                if (!groupMap.has(gk)) {
                                  groupMap.set(gk, []);
                                  groupOrder.push(gk);
                                }
                                groupMap.get(gk)!.push([key, result]);
                              });
                              const getEntryTime = (r: any) =>
                                new Date(
                                  r.last_transfer_update_at ||
                                    r.updated_at ||
                                    r.created_at,
                                ).getTime();

                              // Sort within each group newest-first
                              groupMap.forEach((entries) => {
                                entries.sort(
                                  ([, a], [, b]) => getEntryTime(b) - getEntryTime(a),
                                );
                              });

                              // Sort groups by their most recent entry (newest-first) so
                              // sub-rows overall read in time order, while same-TID rows
                              // stay contiguous for the bracket styling.
                              groupOrder.sort((a, b) => {
                                const maxA = Math.max(
                                  ...groupMap.get(a)!.map(([, r]) => getEntryTime(r)),
                                );
                                const maxB = Math.max(
                                  ...groupMap.get(b)!.map(([, r]) => getEntryTime(r)),
                                );
                                return maxB - maxA;
                              });

                              const rows: React.ReactElement[] = [];

                              groupOrder.forEach((groupKey, groupIdx) => {
                                const entries = groupMap.get(groupKey)!;
                                const transferId = extractTid(entries[0][0]);
                                const groupSize = entries.length;
                                const isGrouped = groupSize > 1;
                                const needsSeparator = groupIdx > 0;

                                entries.forEach(([key, result], entryIdx) => {
                                  const typedResult = result as {
                                    percentage: number;
                                    total_ids_transferred: number;
                                    adserver_name?: string;
                                    adserver_type?: string;
                                    created_at: string | Date;
                                    updated_at?: string | Date;
                                    last_transfer_update_at?: string | Date;
                                    error: string;
                                    ui_error?: string;
                                    status: string;
                                  };

                                  const displayPercentage =
                                    typedResult.status?.toUpperCase() === "ERROR"
                                      ? 0
                                      : typedResult.percentage;

                                  const isFirstInGroup = entryIdx === 0;
                                  // Bracket classes applied to the Transfer ID cell only
                                  const bracketClass = isGrouped
                                    ? entryIdx === 0
                                      ? styles.groupFirst
                                      : entryIdx === entries.length - 1
                                      ? styles.groupLast
                                      : styles.groupMiddle
                                    : "";

                                  rows.push(
                                    <tr
                                      key={key}
                                      className={`${styles.childRow} ${
                                        expandedRows[index] ? styles.childRowActive : ""
                                      } ${isFirstInGroup && needsSeparator ? styles.childRowGroupStart : ""}`}
                                    >
                                      <td></td>

                                      {/* Transfer ID cell — shown on every row.
                                          Bracket classes draw the [ shape on the left edge for grouped rows. */}
                                      <td className={bracketClass}>
                                        {transferId && (
                                          <div className={styles.adserverCell}>
                                            <strong>Transfer ID:</strong>
                                            <div className={styles.idWithIcons}>
                                              <Tooltip text={transferId} placement="bottom">
                                                <span className={styles.queryIdText}>
                                                  {transferId}
                                                </span>
                                              </Tooltip>
                                              <span className={styles.iconWrapper}>
                                                <CopyIcon
                                                  className={styles.icon}
                                                  onClick={() =>
                                                    copyToClipboard(
                                                      transferId,
                                                      `child-${transferId}`,
                                                    )
                                                  }
                                                />
                                                {showCopySuccess === `child-${transferId}` && (
                                                  <span className={styles.copiedTooltip}>
                                                    Copied
                                                  </span>
                                                )}
                                              </span>
                                            </div>
                                          </div>
                                        )}
                                      </td>

                                      {/* Ad Server col — rendered on every row */}
                                      <td>
                                        <div className={styles.adserverCell}>
                                          {typedResult.adserver_name && (
                                            <Tooltip
                                              text={typedResult.adserver_name}
                                              placement="bottom"
                                            >
                                              <div className={styles.adserverNameText}>
                                                <strong>Name:</strong>{" "}
                                                {typedResult.adserver_name}
                                              </div>
                                            </Tooltip>
                                          )}
                                          {typedResult.adserver_type && (
                                            <div className={styles.adserverNameText}>
                                              <strong>Type:</strong>{" "}
                                              {formatAdserverType(typedResult.adserver_type)}
                                            </div>
                                          )}
                                        </div>
                                      </td>

                                      {/* Progress col */}
                                      <td>
                                        <div className={styles.progressContainer}>
                                          <span className={styles.progressText}>
                                            {displayPercentage?.toFixed(2)}% |{" "}
                                            {typedResult.total_ids_transferred?.toLocaleString(
                                              "en-US",
                                            )}
                                          </span>
                                          <div className={styles.progressBar}>
                                            <div
                                              className={styles.progressFill}
                                              style={{ width: `${displayPercentage}%` }}
                                            ></div>
                                          </div>
                                        </div>
                                      </td>

                                      {/* Status col */}
                                      <td>
                                        <div className={styles.statusCellInner}>
                                        <Tooltip
                                          text={getChildStatusTitle(typedResult)}
                                          placement="top"
                                        >
                                          <img
                                            src={getChildStatusIcon(typedResult)}
                                            alt="status"
                                            style={{
                                              cursor:
                                                typedResult.status === "ERROR" &&
                                                (typedResult.ui_error || typedResult.error)
                                                  ? "pointer"
                                                  : "default",
                                            }}
                                            className={styles.statusIcon}
                                            onClick={
                                              typedResult.status === "ERROR" &&
                                              (typedResult.ui_error || typedResult.error)
                                                ? () => setActiveErrorRow(key)
                                                : undefined
                                            }
                                          />
                                        </Tooltip>
                                        {typedResult.error && (
                                          <Tooltip text="View technical error" placement="top">
                                            <button
                                              className={styles.errorInfoBtn}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                setActiveTechErrorRow(key);
                                              }}
                                              aria-label="View technical error"
                                            >
                                              <MdCode className={styles.errorInfoIcon} />
                                            </button>
                                          </Tooltip>
                                        )}
                                        </div>
                                        {activeErrorRow === key && (
                                          <InfoPopup
                                            displayText={getChildErrorInfo(typedResult)}
                                            freeText
                                            isOpen={true}
                                            onClose={() => setActiveErrorRow(null)}
                                            headerText="Information!"
                                          />
                                        )}
                                        {activeTechErrorRow === key && (
                                          <InfoPopup
                                            isOpen={true}
                                            onClose={() => setActiveTechErrorRow(null)}
                                            headerText="Technical Error"
                                          >
                                            <div className={styles.techErrorBody}>
                                              {parseTransferError(typedResult.error).map((part, pi) =>
                                                part.label === null ? (
                                                  <p key={pi} className={styles.techErrorFallback}>{part.value}</p>
                                                ) : (
                                                  <div key={pi} className={styles.techErrorRow}>
                                                    <span className={styles.techErrorLabel}>{part.label}</span>
                                                    {part.variant === "badge" ? (
                                                      <span className={styles.techErrorBadge}>{part.value}</span>
                                                    ) : part.variant === "json" ? (
                                                      <pre className={styles.techErrorPre}>{part.value}</pre>
                                                    ) : part.variant === "code" ? (
                                                      <code className={styles.techErrorCode}>{part.value}</code>
                                                    ) : (
                                                      <span className={styles.techErrorValue}>{part.value}</span>
                                                    )}
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </InfoPopup>
                                        )}
                                      </td>

                                      {/* Date col */}
                                      <td className={styles.textAlignLeft}>
                                        {(() => {
                                          const parts = formatDateTimeParts(
                                            typedResult.last_transfer_update_at ||
                                              typedResult.updated_at ||
                                              typedResult.created_at,
                                          );
                                          if (!parts) return <span>—</span>;
                                          return (
                                            <div className={styles.dateTimeCell}>
                                              <span className={styles.dateText}>
                                                {parts.date}
                                              </span>
                                              <span className={styles.timeText}>
                                                {parts.time}
                                              </span>
                                            </div>
                                          );
                                        })()}
                                      </td>
                                    </tr>,
                                  );
                                });
                              });

                              return rows;
                            })()
                          ) : (
                            <tr
                              className={`${styles.expandedRow} ${
                                expandedRows[index] ? "active" : ""
                              } ${styles.expandedContent}`}
                            >
                              <td
                                className={`${styles.expandableRow} ${styles.verticalLine}`}
                              ></td>
                              <td colSpan={7} className={styles.noData}>
                                No records available.
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    </React.Fragment>
                  ))
                )}
              </tbody>
            </table>}
          </div>

          <div className={styles.tableFooter}>
            <button
              className={
                currentPage === 1 ? styles.navigationDisable : styles.prevPage
              }
              onClick={handlePreviousPageClick}
              disabled={currentPage === 1}
            >
              Previous Page
            </button>
            <span className={styles.pageInfo}>Page {currentPage}</span>
            <button
              className={
                (tableData?.Items?.length < rowsPerPage)
                  ? styles.navigationDisable
                  : styles.nextPage
              }
              onClick={handleNextPageClick}
              disabled={!tableData?.Items?.length || tableData.Items.length < rowsPerPage}
            >
              Next Page
            </button>
          </div>
        </div>
      )}
      </div>
    </LayoutContainer>
  );
};

export default ActivationHistory;
